var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChaves = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 110,
    viewBox: "0 0 109 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M98.5375 6.61475H10.4655C8.05751 6.61475 6.10547 8.58469 6.10547 11.0147V65.0467C6.10547 67.4768 8.05751 69.4467 10.4655 69.4467H98.5375C100.945 69.4467 102.897 67.4768 102.897 65.0467V11.0147C102.897 8.58469 100.945 6.61475 98.5375 6.61475Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.5492 6.81274H10.3028C7.99114 6.81274 6.11719 8.70389 6.11719 11.0367V64.4894C6.11719 66.8223 7.99114 68.7134 10.3028 68.7134H98.5492C100.861 68.7134 102.735 66.8223 102.735 64.4894V11.0367C102.735 8.70389 100.861 6.81274 98.5492 6.81274Z",
    fill: "white",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11719 58.3992H102.735",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11719 48.0811H102.735",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11719 37.7632H102.735",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11719 27.4487H102.735",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11719 17.1309H102.735",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6328 6.81274V68.7134",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5273 6.81274V68.7134",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4258 6.81274V68.7134",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3242 6.81274V68.7134",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2188 6.81274V68.7134",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9023 48.2097C56.5221 53.6358 56.5221 62.4375 61.9023 67.8671C65.6873 71.6868 71.1259 72.8213 75.8907 71.2635L89.7176 85.2207C91.0446 86.5599 92.9629 87.1219 94.7952 86.7091C95.8094 86.4801 96.741 85.9632 97.4767 85.2207L98.8381 83.8469V78.681C98.8381 77.432 97.9924 76.3461 96.7926 76.0512C95.8197 75.8119 95.06 75.0451 94.8227 74.0633L94.7402 73.7268C94.4858 72.679 93.6401 71.8811 92.5847 71.7007L90.9861 71.4266C89.862 71.2323 88.9819 70.3442 88.7928 69.2132C88.6484 68.3493 88.4834 67.3709 88.37 66.6944C88.2772 66.1428 88.0159 65.6328 87.624 65.2338L84.75 62.3334C86.2935 57.5249 85.1728 52.0364 81.3878 48.2167C76.0111 42.7871 67.2894 42.7871 61.9092 48.2167L61.9023 48.2097ZM71.2428 57.6394C69.8127 59.0827 67.4956 59.0827 66.0655 57.6394C64.6354 56.1962 64.6354 53.8544 66.0655 52.4111C67.4956 50.9679 69.8161 50.9679 71.2428 52.4111C72.673 53.8544 72.673 56.1962 71.2428 57.6394Z",
    fill: "#606060"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6718 46.9053C57.2917 52.3313 57.2917 61.1331 62.6718 66.5626C66.4569 70.3824 71.8955 71.5168 76.6603 69.9591L90.4871 83.9163C91.8141 85.2554 93.7324 85.8175 95.5648 85.4046C96.5789 85.1756 97.5106 84.6587 98.2463 83.9163L99.6076 82.5424V77.3766C99.6076 76.1276 98.7619 75.0417 97.5621 74.7468C96.5892 74.5074 95.8295 73.7407 95.5923 72.7589L95.5098 72.4223C95.2554 71.3746 94.4097 70.5766 93.3543 70.3962L91.7557 70.1222C90.6315 69.9279 89.7514 69.0397 89.5624 67.9087C89.418 67.0448 89.253 66.0665 89.1395 65.39C89.0467 64.8383 88.7854 64.3283 88.3935 63.9294L85.5195 61.029C87.0631 56.2205 85.9424 50.732 82.1573 46.9122C76.7806 41.4827 68.0589 41.4827 62.6787 46.9122L62.6718 46.9053ZM72.0158 56.3384C70.5857 57.7817 68.2686 57.7817 66.8385 56.3384C65.4083 54.8952 65.4083 52.5534 66.8385 51.1101C68.2686 49.6669 70.5891 49.6669 72.0158 51.1101C73.4459 52.5534 73.4459 54.8952 72.0158 56.3384Z",
    fill: "#999E9C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4317 56.7578C70.7747 58.43 68.0795 58.43 66.4225 56.7578C64.7654 55.0856 64.7654 52.3656 66.4225 50.6934C68.0795 49.0212 70.7747 49.0212 72.4317 50.6934C74.0888 52.3656 74.0888 55.0856 72.4317 56.7578ZM67.2544 51.5295C66.0546 52.7403 66.0546 54.7074 67.2544 55.9182C68.4542 57.129 70.4034 57.129 71.6032 55.9182C72.803 54.7074 72.803 52.7403 71.6032 51.5295C70.4034 50.3187 68.4542 50.3187 67.2544 51.5295Z",
    fill: "#004876"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4317 56.7578C70.7747 58.43 68.0795 58.43 66.4225 56.7578C64.7654 55.0856 64.7654 52.3656 66.4225 50.6934C68.0795 49.0212 70.7747 49.0212 72.4317 50.6934C74.0888 52.3656 74.0888 55.0856 72.4317 56.7578ZM67.2544 51.5295C66.0546 52.7403 66.0546 54.7074 67.2544 55.9182C68.4542 57.129 70.4034 57.129 71.6032 55.9182C72.803 54.7074 72.803 52.7403 71.6032 51.5295C70.4034 50.3187 68.4542 50.3187 67.2544 51.5295Z",
    fill: "#5E5E5E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1395 53.0114C59.3527 52.2378 59.6277 51.4815 59.9784 50.7494C59.1877 48.9245 59.5314 46.718 61.0063 45.2262C62.9314 43.2834 66.0598 43.2834 67.985 45.2262C69.9067 47.1691 69.9067 50.3262 67.985 52.269C67.5106 52.7478 66.9605 53.112 66.3727 53.3549C66.297 54.0002 66.4208 54.6663 66.7474 55.2457C67.6859 54.9161 68.5694 54.3714 69.3189 53.6186C71.9797 50.9333 71.9797 46.5654 69.3189 43.8836C66.658 41.1983 62.3298 41.1983 59.6724 43.8836C57.2075 46.3711 57.0287 50.3123 59.1395 53.0114Z",
    fill: "#A3A3A3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4273 60.9387L82.7148 75.9783L84.0281 77.3904L86.4827 62.0038L85.606 61.2093",
    fill: "#D8D8D8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4034 62.9299L84.6875 77.9695L86.0042 79.385L88.4588 63.995L87.5821 63.2005",
    fill: "#D8D8D8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8006 70.7119L91.4491 84.2285C91.3907 84.5581 91.5557 84.8807 91.8754 85.0646C92.5148 85.4323 93.4052 85.0715 93.5015 84.4089L95.2651 72.117C95.3167 71.7666 95.1207 71.4335 94.7666 71.267L94.1925 70.7431",
    fill: "#D8D8D8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2769 41.2744C53.3262 41.2744 53.3663 41.234 53.3663 41.1842C53.3663 41.1344 53.3262 41.094 53.2769 41.094C53.2275 41.094 53.1875 41.1344 53.1875 41.1842C53.1875 41.234 53.2275 41.2744 53.2769 41.2744Z",
    fill: "#FEFDFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1128 41.0557C58.1622 41.0557 58.2022 41.0153 58.2022 40.9654C58.2022 40.9156 58.1622 40.8752 58.1128 40.8752C58.0635 40.8752 58.0234 40.9156 58.0234 40.9654C58.0234 41.0153 58.0635 41.0557 58.1128 41.0557Z",
    fill: "#FEFDFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4246 44.2754C66.4246 44.2754 69.2161 44.213 69.3846 49.4413L68.3567 49.5835C68.3567 49.5835 68.9789 45.226 65.5273 44.723L66.4246 44.2789V44.2754Z",
    fill: "#7F7F7F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6211 44.2927C66.6211 44.2927 69.9833 45.3474 69.2613 50.0276",
    stroke: "#232323",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9665 41.3923C46.4032 41.3923 46.7572 41.035 46.7572 40.5943C46.7572 40.1536 46.4032 39.7964 45.9665 39.7964C45.5298 39.7964 45.1758 40.1536 45.1758 40.5943C45.1758 41.035 45.5298 41.3923 45.9665 41.3923Z",
    fill: "#7F7F7F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6462 40.5944C48.0829 40.5944 48.4369 40.2372 48.4369 39.7965C48.4369 39.3558 48.0829 38.9985 47.6462 38.9985C47.2095 38.9985 46.8555 39.3558 46.8555 39.7965C46.8555 40.2372 47.2095 40.5944 47.6462 40.5944Z",
    fill: "#7F7F7F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4743 40.0253C49.911 40.0253 50.265 39.6681 50.265 39.2274C50.265 38.7867 49.911 38.4294 49.4743 38.4294C49.0376 38.4294 48.6836 38.7867 48.6836 39.2274C48.6836 39.6681 49.0376 40.0253 49.4743 40.0253Z",
    fill: "#7F7F7F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4083 39.349C51.8431 39.349 52.1956 38.9933 52.1956 38.5545C52.1956 38.1157 51.8431 37.76 51.4083 37.76C50.9736 37.76 50.6211 38.1157 50.6211 38.5545C50.6211 38.9933 50.9736 39.349 51.4083 39.349Z",
    fill: "#7F7F7F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3649 39.2275C53.8016 39.2275 54.1556 38.8702 54.1556 38.4295C54.1556 37.9888 53.8016 37.6316 53.3649 37.6316C52.9282 37.6316 52.5742 37.9888 52.5742 38.4295C52.5742 38.8702 52.9282 39.2275 53.3649 39.2275Z",
    fill: "#7F7F7F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.193 39.4565C55.6297 39.4565 55.9837 39.0992 55.9837 38.6585C55.9837 38.2178 55.6297 37.8606 55.193 37.8606C54.7564 37.8606 54.4023 38.2178 54.4023 38.6585C54.4023 39.0992 54.7564 39.4565 55.193 39.4565Z",
    fill: "#7F7F7F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8927 40.1468C57.3275 40.1468 57.68 39.7911 57.68 39.3523C57.68 38.9136 57.3275 38.5579 56.8927 38.5579C56.4579 38.5579 56.1055 38.9136 56.1055 39.3523C56.1055 39.7911 56.4579 40.1468 56.8927 40.1468Z",
    fill: "#7F7F7F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4708 41.0455C58.9056 41.0455 59.2581 40.6898 59.2581 40.251C59.2581 39.8122 58.9056 39.4565 58.4708 39.4565C58.0361 39.4565 57.6836 39.8122 57.6836 40.251C57.6836 40.6898 58.0361 41.0455 58.4708 41.0455Z",
    fill: "#7F7F7F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M59.713 42.2181C60.1478 42.2181 60.5003 41.8624 60.5003 41.4236C60.5003 40.9849 60.1478 40.6292 59.713 40.6292C59.2783 40.6292 58.9258 40.9849 58.9258 41.4236C58.9258 41.8624 59.2783 42.2181 59.713 42.2181Z",
    fill: "#7F7F7F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5379 40.6257C46.6307 41.4792 45.8125 41.1947 45.8125 41.1947L46.5379 40.6257Z",
    fill: "#605E5E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3477 40.4695C45.3477 40.4695 45.3958 39.8693 46.0112 40.0254L45.3477 40.4695Z",
    fill: "#ADADAD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M48.241 39.8032C48.3338 40.6567 47.5156 40.3722 47.5156 40.3722L48.241 39.8032Z",
    fill: "#605E5E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0547 39.6472C47.0547 39.6472 47.1028 39.047 47.7182 39.2032L47.0547 39.6472Z",
    fill: "#ADADAD"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0652 39.2346C50.158 40.0881 49.3398 39.8036 49.3398 39.8036L50.0652 39.2346Z",
    fill: "#605E5E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8789 39.0784C48.8789 39.0784 48.927 38.4782 49.5458 38.6343L48.8789 39.0784Z",
    fill: "#ADADAD"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9244 38.2734C52.4195 38.9708 51.5703 39.1269 51.5703 39.1269L51.9244 38.2734Z",
    fill: "#605E5E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8166 38.7245C50.8166 38.7245 50.5656 38.1798 51.1776 38.0063L50.8166 38.7245Z",
    fill: "#ADADAD"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8697 38.1348C54.3648 38.8321 53.5156 38.9882 53.5156 38.9882L53.8697 38.1348Z",
    fill: "#605E5E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M52.758 38.5892C52.758 38.5892 52.507 38.0446 53.119 37.8711L52.758 38.5892Z",
    fill: "#ADADAD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6769 38.3149C56.2304 38.9672 55.3984 39.1962 55.3984 39.1962L55.6769 38.3149Z",
    fill: "#605E5E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6086 38.8631C54.6086 38.8631 54.313 38.3427 54.9077 38.1172L54.6086 38.8631Z",
    fill: "#ADADAD"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3644 39.0088C57.9179 39.661 57.0859 39.89 57.0859 39.89L57.3644 39.0088Z",
    fill: "#605E5E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2961 39.5606C56.2961 39.5606 56.0005 39.0402 56.5952 38.8147L56.2961 39.5606Z",
    fill: "#ADADAD"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M59.056 40.2715C59.1282 41.1249 58.3203 40.8231 58.3203 40.8231L59.056 40.2715Z",
    fill: "#605E5E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M57.875 40.0877C57.875 40.0877 57.9334 39.491 58.5488 39.6575L57.875 40.0877Z",
    fill: "#ADADAD"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M60.306 41.4446C60.3782 42.298 59.5703 41.9962 59.5703 41.9962L60.306 41.4446Z",
    fill: "#605E5E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1211 41.2606C59.1211 41.2606 59.1795 40.6638 59.7949 40.8304L59.1211 41.2606Z",
    fill: "#ADADAD"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6694 102.278C83.6619 102.278 106.354 100.595 106.354 98.5196C106.354 96.4439 83.6619 94.7612 55.6694 94.7612C27.6768 94.7612 4.98438 96.4439 4.98438 98.5196C4.98438 100.595 27.6768 102.278 55.6694 102.278Z",
    fill: "#E2E2E2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8165 42.8011L34.5524 65.8595L43.44 69.5927C43.6261 69.6639 43.7839 69.8216 43.8487 70.0101L45.7317 74.4627C45.9735 75.0248 45.7067 75.6597 45.1524 75.8925L33.2848 80.7875L34.4725 83.6239C34.9562 84.7481 36.2391 85.296 37.3477 84.8303L59.3962 75.7408C60.5178 75.2862 61.0255 73.9943 60.5418 72.87L47.8552 42.8134C47.3262 41.5837 45.9955 41.172 44.9562 41.6087C44.4711 41.8125 44.027 42.2065 43.8036 42.7899",
    fill: "url(#paint0_linear_35133_17700)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1679 61.5725L23.3652 82.72C23.9281 84.0098 25.3977 84.6497 26.6609 84.1445L33.4024 81.454L30.896 75.661C30.7998 75.4631 30.8015 75.2341 30.8838 75.0514L34.5301 65.7627L17.3417 58.3759C16.668 58.0969 15.9977 58.0975 15.4403 58.3331C14.2612 58.7953 13.5444 60.1844 14.1567 61.5858",
    fill: "#079D56"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8794 74.7819C30.8115 74.9667 30.8053 75.1825 30.8787 75.356L33.1078 80.7632L44.8795 75.8172C45.4294 75.5819 45.6981 74.9505 45.4634 74.3952L43.6362 69.9965C43.5501 69.812 43.408 69.6679 43.2354 69.586L34.4771 65.9557L30.8794 74.7819Z",
    fill: "url(#paint1_linear_35133_17700)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35133_17700",
    x1: 11.1131,
    y1: -59.4056,
    x2: 34.0558,
    y2: -113.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F58521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FFB819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FFB819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB819"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35133_17700",
    x1: 83.4999,
    y1: 75.947,
    x2: 86.7703,
    y2: 83.7407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#006B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#089E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#089E57"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChaves);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chaves.4cd6d54f25475f722df8a51221be3a9c.svg";